<template>
  <div class="page-outer">
    <div class="page-header page-header-fixed-form">
      <div class="header-left">
        <h1 class="page-title">問卷管理</h1>
      </div>
      <div class="header-actions">
        <router-link :to="{ name: 'CreateQuestionnaire' }" class="btn btn-primary">新增問卷</router-link>
      </div>
    </div>
    <div class="page-container">
      <div class="page-toolbar">
        <div class="filter-group">
          <input v-model="keyword" class="form-control" placeholder="搜尋問卷名稱" @keyup.enter="load" />
        </div>
        <div class="filter-group">
          <select v-model="status" class="form-control" @change="load">
            <option value="">全部狀態</option>
            <option value="draft">草稿</option>
            <option value="published">發布中</option>
            <option value="ended">已結束</option>
            <option value="deleted">已刪除</option>
          </select>
        </div>
      </div>
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>名稱</th>
              <th>狀態</th>
              <th>收卷期間</th>
              <th>上限</th>
              <th>回答數</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="items.length === 0">
              <td colspan="6">尚無問卷</td>
            </tr>
            <tr v-for="item in items" :key="item.id">
              <td>{{ item.name }}</td>
              <td>{{ statusLabel(item) }}</td>
              <td>{{ period(item) }}</td>
              <td>{{ item.responseLimit || '不限' }}</td>
              <td>{{ item.responseCount || 0 }}</td>
              <td>
                <div class="action-buttons">
                  <template v-if="item.deletedAt">
                    <button
                      type="button"
                      class="btn btn-sm btn-secondary"
                      title="回覆"
                      @click="$router.push({ name: 'QuestionnaireResponses', params: { id: item.id } })"
                    >
                      <i class="ri-file-list-3-line"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-secondary"
                      title="統計"
                      @click="$router.push({ name: 'QuestionnaireStats', params: { id: item.id } })"
                    >
                      <i class="ri-pie-chart-2-line"></i>
                    </button>
                  </template>
                  <template v-else>
                    <button
                      type="button"
                      class="btn btn-sm btn-secondary"
                      title="編輯"
                      @click="$router.push({ name: 'EditQuestionnaire', params: { id: item.id } })"
                    >
                      <i class="ri-edit-line"></i>
                    </button>
                    <button
                      v-if="item.status !== 'published'"
                      type="button"
                      class="btn btn-sm btn-success"
                      title="發布"
                      @click="publishItem(item)"
                    >
                      <i class="ri-send-plane-line"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-danger"
                      title="刪除"
                      @click="removeItem(item)"
                    >
                      <i class="ri-delete-bin-line"></i>
                    </button>
                  </template>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { questionnaireService } from '@/api/modules/questionnaires.js';
import { showSuccess, showError, showDeleteConfirmDeferred } from '@/utils/swal.js';

export default {
  name: 'QuestionnaireList',
  data() {
    return { items: [], keyword: '', status: '' };
  },
  mounted() {
    this.load();
  },
  methods: {
    statusLabel(item) {
      if (item.deletedAt) return '已刪除';
      return { draft: '草稿', published: '發布中', ended: '已結束' }[item.status] || item.status;
    },
    async load() {
      const response = await questionnaireService.list({ keyword: this.keyword, status: this.status, page: 1, limit: 50 });
      this.items = response?.data?.items || [];
    },
    async publishItem(item) {
      try {
        await questionnaireService.publish(item.id);
        await showSuccess('發布成功');
        await this.load();
      } catch (error) {
        await showError('發布失敗', error?.response?.data?.message || '發布失敗');
      }
    },
    async removeItem(item) {
      const confirmed = await showDeleteConfirmDeferred(
        item.name,
        `「${item.name}」會從列表移出，回覆仍保留。可在狀態選「已刪除」查看回覆與統計。填寫連結會失效。`
      );
      if (!confirmed) return;
      try {
        await questionnaireService.remove(item.id);
        await showSuccess('刪除成功');
        await this.load();
      } catch (error) {
        await showError('刪除失敗', error?.response?.data?.message || '刪除失敗');
      }
    },
    period(item) {
      const start = item.startsAt ? new Date(item.startsAt).toLocaleString('zh-TW') : '發布後';
      const end = item.endsAt ? new Date(item.endsAt).toLocaleString('zh-TW') : '不限';
      return `${start} ～ ${end}`;
    }
  }
};
</script>

<style scoped>
@import '~@/assets/scss/components/_list-page-common.scss';

.table-wrapper table { min-width: 760px; }
</style>
